/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Password/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Password({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/Signature/Content/Content/Password"
  
}) {
let constantData = 'To access this document, you can use any of the following dates of birth as a password:'
let signatureAllowedBirthDatesValueData = fromData.useDataFormat({ viewPath,
context: 'signature',
path: 'allowed_birth_dates',
format: fromHelpers.getDateOfBirths,
})
let aggregateData = fromAggregate.join(constantData, signatureAllowedBirthDatesValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 data="'To access this document, you can use any of the following dates of birth as a password:'"
 data="signature.allowed_birth_dates"
 format="helpers.js getDateOfBirths"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}